var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnumLogoShortBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#597897",
  d: "M21.397 13.908a6.44 6.44 0 0 1-2.865-2.424A6.3 6.3 0 0 1 17.53 7.9c-.001-.828.167-1.647.494-2.41a6.2 6.2 0 0 1 1.41-2.03 6.3 6.3 0 0 1 2.102-1.331A6.4 6.4 0 0 1 24 1.708c.963 0 1.914.212 2.783.619.87.407 1.635 1 2.242 1.736a6.3 6.3 0 0 1 1.265 2.515c.227.92.242 1.879.044 2.806a6.3 6.3 0 0 1-1.187 2.552 6.45 6.45 0 0 1-2.187 1.802 6.56 6.56 0 0 1-5.563.168z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#015294",
  d: "M9 33.18V17.442h9.042v15.132c0 4.237 2.258 6.052 5.957 6.052 3.494 0 5.961-1.816 5.961-6.052V17.443H39v15.736c0 5.246-2.673 13.115-15 13.115-12.122 0-15-7.87-15-13.114"
})));
export default SvgUnumLogoShortBlue;